(() => {
  let reloadTimeout = null;
  let refreshTimeout = null;
  let longRefreshTimeout = null;

  const isCartPage = () => {
    const path = window.location.pathname;
    return path === '/cart' || path === '/cart/';
  };

  const refreshNow = () => {
    if (window.goCart && typeof window.goCart.fetchCart === 'function') {
      window.goCart.fetchCart();
    }
  };

  /**
   * Debounced UI Refresh
   * Fires a quick update (200ms) and a safety update (5s)
   */
  const scheduleUIUpdate = () => {
    // Clear existing short-term timer
    if (refreshTimeout) clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(refreshNow, 200);

    // Clear existing long-term safety timer
    if (longRefreshTimeout) clearTimeout(longRefreshTimeout);
    longRefreshTimeout = setTimeout(refreshNow, 5000);
  };

  /**
   * Debounced Hard Reload
   * Resets the timer on every call so the reload only happens 
   * after the user has stopped interacting for 'delay' ms.
   */
  const scheduleReload = (delay = 3000) => {
    if (!isCartPage()) return;

    if (reloadTimeout) clearTimeout(reloadTimeout);
    
    reloadTimeout = setTimeout(() => {
      window.location.reload();
    }, delay);
  };

  // --- Network Interceptors ---
  
  // 1. Fetch Interceptor
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args === 'string' ? args : (args && args.url) || '';
    const isCartRequest = /\/cart\/(add|change|update)\.js($|\?)/.test(url);
    
    return originalFetch.apply(this, args).then(response => {
      if (isCartRequest && response.ok) {
        scheduleUIUpdate();
      }
      return response;
    });
  };

  // 2. jQuery Interceptor
  if (window.jQuery && jQuery.ajax) {
    const originalAjax = jQuery.ajax;
    jQuery.ajax = function(opts) {
      const url = typeof opts === 'string' ? opts : (opts && opts.url) || '';
      const isCartRequest = /\/cart\/(add|change|update)\.js($|\?)/.test(url);
      const jqXHR = originalAjax.apply(this, arguments);

      if (isCartRequest && jqXHR && jqXHR.always) {
        jqXHR.always(() => scheduleUIUpdate());
      }
      return jqXHR;
    };
  }

  // --- Event Listeners ---

  document.addEventListener('click', e => {
    const target = e.target;

    // Standard Shopify plus/minus buttons
    if (target.matches('button[name="plus"], button[name="minus"]')) {
      scheduleReload(3500);
    }

    // Remove buttons
    if (target.closest('.cartitemm-remove')) {
      scheduleReload(3000);
    }

    // Direct Add-to-cart links
    if (target.closest('a[href*="/cart/add"]')) {
      scheduleReload(3000);
    }

    // Go-Cart specific elements
    if (target.closest('.js-go-cart-quantity-plus, .js-go-cart-quantity-minus, .js-go-cart-remove-from-cart, .js-go-cart-add-to-cart')) {
      // Small buffer to let the click initiate the request before scheduling UI check
      setTimeout(scheduleUIUpdate, 100);
      scheduleReload(2500);
    }
  }, true);

  // Form Submissions
  document.addEventListener('submit', e => {
    if (e.target.matches('form[action*="/cart/add"]')) {
      scheduleReload(3500);
    }
  });

})();